import React from 'react';
import { observer } from 'mobx-react-lite';
import QuoteAddEmployeesPageStore, {
  QuoteAddEmployeesPageStoreContext,
} from 'store/pages/quote/add-employees/pageStore';
import { PageContent } from 'components/quote/add-employees';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';

/* TESTING_POLICY: CYPRESS_ONLY */

const QuoteAddEmployeesPage: React.FC = observer(() => {
  const domainParams = useQuoteDomainParams();

  return (
    <QuoteAddEmployeesPageStoreContext.Provider value={new QuoteAddEmployeesPageStore(domainParams)}>
      <PageContent />
    </QuoteAddEmployeesPageStoreContext.Provider>
  );
});

export default QuoteAddEmployeesPage;
